/**
 * When the parent page should hand the demo iframe a session.
 *
 * The iframe only reports `interaction` for trusted events INSIDE the frame.
 * A visitor who scrolls the marketing page down to the demo never touches the
 * frame, so the app sat signed out until something else (the LINE chat)
 * minted a session. The parent now also authenticates when the visitor has
 * engaged with the page at all (a real, trusted input event) AND the frame is
 * on screen — once per frame load, and never when a token already exists.
 * Synthetic events do not count, so bots and prerenders allocate nothing.
 */

const ENGAGEMENT_EVENTS = new Set(['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll']);

export function isEngagementEvent(event: { type: string; isTrusted: boolean }): boolean {
  return event.isTrusted && ENGAGEMENT_EVENTS.has(event.type);
}

export function createDemoFrameAuthTrigger(): {
  update: (state: { engaged: boolean; visible: boolean; hasToken: boolean }) => boolean;
} {
  let requested = false;
  return {
    update({ engaged, visible, hasToken }) {
      if (requested || hasToken || !engaged || !visible) return false;
      requested = true;
      return true;
    },
  };
}
